var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 291,
    viewBox: "0 0 132 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7617 12.88V8.84131C44.7617 3.92946 47.6038 0 51.1565 0H81.1565C84.7091 0 87.5512 3.92946 87.5512 8.84131V12.88H44.7617Z",
    fill: "url(#paint0_linear_1387_24261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6038 9.49633C58.0249 9.27802 47.0512 7.64075 45.1565 5.78516C44.9196 6.76753 44.7617 7.74988 44.7617 8.84141V12.8801H87.5512V9.16888C87.2354 9.16888 75.0775 9.71463 65.6038 9.38717V9.49633Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.632 20.5208H119.526C117.789 15.9364 114.237 12.9893 110.368 12.9893H21.7895C17.9211 12.9893 14.4474 16.0455 12.6316 20.5208H11.5263C5.21053 20.5208 0 27.6157 0 36.457V267.532C0 276.265 5.13158 283.469 11.5263 283.469H12.6316C14.4474 287.944 17.9211 291 21.7105 291H110.289C114.158 291 117.632 287.944 119.368 283.469H120.474C126.789 283.469 132 276.374 132 267.532V36.457C132 27.7248 126.868 20.5208 120.474 20.5208H120.632Z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6854 25.2139H120.633C125.133 25.2139 128.685 30.2349 128.685 36.3474V267.423C128.685 273.535 125.054 278.556 120.633 278.556H11.6854C7.26439 278.556 3.63281 273.535 3.63281 267.423V36.3474C3.63281 30.2349 7.26439 25.2139 11.6854 25.2139Z",
    fill: "#F2F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "battery-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6854 25.2139H120.633C125.133 25.2139 128.685 30.2349 128.685 36.3474V267.423C128.685 273.535 125.054 278.556 120.633 278.556H11.6854C7.26439 278.556 3.63281 273.535 3.63281 267.423V36.3474C3.63281 30.2349 7.26439 25.2139 11.6854 25.2139Z",
    fill: "url(#paint1_linear_1387_24261)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84805 268V270.369C3.84805 275.192 7.46005 279 11.8573 279H120.217C124.693 279 128.227 275.108 128.227 270.369V268H3.76953H3.84805Z",
    fill: "#B9B9B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 278.666C15.7887 282.923 18.5518 286.198 21.8676 286.198H110.447C113.762 286.198 116.525 282.923 117.236 278.666H15.1571H15.0781Z",
    fill: "#90908F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.238 25.1973C116.528 20.9403 113.765 17.6657 110.449 17.6657L21.8699 17.6657C18.5541 17.6657 15.7909 20.9403 15.0804 25.1973L117.159 25.1973L117.238 25.1973Z",
    fill: "#90908F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.09 39V33.8148C129.09 28.8889 125.451 25 121.021 25H11.8394C7.32979 25 3.76953 28.9753 3.76953 33.8148V39H129.17H129.09Z",
    fill: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.896 204.548V176.496L7.42188 200.4V228.562L124.896 204.548Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42188 157.394V185.447L124.896 161.433V133.381L7.42188 157.394Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42188 243.515V261.962H124.896V219.502L7.42188 243.515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1387_24261",
    x1: 44.7617,
    y1: 6.54913,
    x2: 87.5512,
    y2: 6.54913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1387_24261",
    x1: 3.63055,
    y1: 200.622,
    x2: 128.762,
    y2: 200.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8513F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1387_24261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.156 122.578) scale(84.3158 116.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEDC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImBattery);
export default __webpack_public_path__ + "static/media/im-battery.29ab1608d155f9e31dfcc088bd497f7a.svg";
export { ForwardRef as ReactComponent };